export default "__VITE_ASSET__0tlXVDv8__"